export default "__VITE_ASSET__DkK0Ije2__"